/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PageDetailsDto from './PageDetailsDto';

/**
 * The GameSessionDto model module.
 * @module model/GameSessionDto
 * @version v0
 */
class GameSessionDto {
    /**
     * Constructs a new <code>GameSessionDto</code>.
     * @alias module:model/GameSessionDto
     */
    constructor() { 
        
        GameSessionDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameSessionDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameSessionDto} obj Optional instance to populate.
     * @return {module:model/GameSessionDto} The populated <code>GameSessionDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameSessionDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('sessionType')) {
                obj['sessionType'] = ApiClient.convertToType(data['sessionType'], 'String');
            }
            if (data.hasOwnProperty('active')) {
                obj['active'] = ApiClient.convertToType(data['active'], 'Boolean');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('completedAt')) {
                obj['completedAt'] = ApiClient.convertToType(data['completedAt'], 'Date');
            }
            if (data.hasOwnProperty('lastVisitedPageId')) {
                obj['lastVisitedPageId'] = ApiClient.convertToType(data['lastVisitedPageId'], 'Number');
            }
            if (data.hasOwnProperty('incompletePage')) {
                obj['incompletePage'] = PageDetailsDto.constructFromObject(data['incompletePage']);
            }
            if (data.hasOwnProperty('wasJustCreated')) {
                obj['wasJustCreated'] = ApiClient.convertToType(data['wasJustCreated'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameSessionDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameSessionDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['sessionType'] && !(typeof data['sessionType'] === 'string' || data['sessionType'] instanceof String)) {
            throw new Error("Expected the field `sessionType` to be a primitive type in the JSON string but got " + data['sessionType']);
        }
        // validate the optional field `incompletePage`
        if (data['incompletePage']) { // data not null
          PageDetailsDto.validateJSON(data['incompletePage']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
GameSessionDto.prototype['id'] = undefined;

/**
 * @member {Number} userId
 */
GameSessionDto.prototype['userId'] = undefined;

/**
 * @member {String} sessionType
 */
GameSessionDto.prototype['sessionType'] = undefined;

/**
 * @member {Boolean} active
 */
GameSessionDto.prototype['active'] = undefined;

/**
 * @member {Date} createdAt
 */
GameSessionDto.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
GameSessionDto.prototype['updatedAt'] = undefined;

/**
 * @member {Date} completedAt
 */
GameSessionDto.prototype['completedAt'] = undefined;

/**
 * ID of the last page visited in this session
 * @member {Number} lastVisitedPageId
 */
GameSessionDto.prototype['lastVisitedPageId'] = undefined;

/**
 * @member {module:model/PageDetailsDto} incompletePage
 */
GameSessionDto.prototype['incompletePage'] = undefined;

/**
 * Indicates if the session was just created (true) or already existed (false). Only present in getActiveGameSession endpoint response.
 * @member {Boolean} wasJustCreated
 */
GameSessionDto.prototype['wasJustCreated'] = undefined;






export default GameSessionDto;

